/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PromosInputs */



/**
* | output |
* | --- |
* | "Promos" |
*
* @param {Nav_PromosInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_promos = /** @type {((inputs?: Nav_PromosInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PromosInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Promos")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Promos")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("宣传卡")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("特典卡")
	if (locale === "ko") return /** @type {LocalizedString} */ ("프로모")
	return /** @type {LocalizedString} */ ("Promos")
});